import type { ComponentProps, ReactNode } from 'react';
import type { ShopperBasketsV2, ShopperSearch } from '@/scapi';
import type { TFunction } from 'i18next';

type SearchHit = ShopperSearch.schemas['ProductSearchHit'];
export type ProductItem = ShopperBasketsV2.schemas['ProductItem'];

export type ProductTileCustomLayout = 'vertical' | 'horizontal' | 'vertical-event';

export interface ProductTileCustomCardProps extends ComponentProps<'div'> {
    product: SearchHit;
    productName: string;
    brand?: string;
    productUrl: string;
    effectiveImgAspectRatio: number;
    handleProductClick?: (product: SearchHit) => void;
    productHighlight?: string;
    eatingList: string[];
    priceAndWeight: ReactNode;
    tileBasketLine: ProductItem | undefined;
    basketControlsDisabled?: boolean;
    t: TFunction<'product'>;
    listFormatted?: string | null;
    isOnSale: boolean;
}

/** Figma card-product (37:37205): PLP shell padding, radius, and elevation. */
export const PRODUCT_TILE_CUSTOM_CARD_SHELL_CLASS =
    'p-2 rounded-3xl bg-card text-card-foreground shadow-[0_4px_12px_0_rgba(0,0,0,0.05)]';

/** Figma image well fill — sand/95 behind product media. */
export const PRODUCT_TILE_CUSTOM_SAND_PLACEHOLDER = 'bg-[var(--sand-95)]';
